export function apiListAdImageWrapper(res) {
    if (res?.resultItems && Array.isArray(res.resultItems)) {
        fixAdImages(res.resultItems);
    }
    return res;
}

function fixAdImages(images) {
    images
        .filter((item) => item.imageurl !== undefined)
        .forEach((item) => {
            if (!item.imageurl.includes('http')) {
                item.imageurl = prependImageUrl(item.imageurl);
            }
        });
}

export function apiRecommendedAdImageWrapper(res) {
    if (res?.items && Array.isArray(res.items)) {
        fixRecommendationImages(res.items);
    } else {
        try {
            const obj = JSON.parse(res);

            fixRecommendationImages(obj.items);

            res = JSON.stringify(obj);
        } catch (error) {
            console.log(`apiRecommendedAdImageWrapper failed with ${error}`);
        }
    }

    return res;
}

function fixRecommendationImages(images) {
    images
        .filter((item) => item.image !== undefined && item.image.isAbsolute === false)
        .forEach((item) => {
            item.image.url = prependImageUrl(item.image.url);
        });
}

export function prependImageUrl(imageUrl) {
    // TODO: https://nmp-jira.atlassian.net/browse/REIS-7690
    return `https://images.finncdn.no/dynamic/default/${imageUrl}`;
}
